import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DeleteAccountBottomSheetComponent} from './delete-account-bottom-sheet/delete-account-bottom-sheet.component';
import {DeleteAccountModalComponent} from './delete-account-modal/delete-account-modal.component';
import {TranslateModule} from "@ngx-translate/core";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {ButtonModule} from '../button/button.module';


@NgModule({
  declarations: [
    DeleteAccountBottomSheetComponent,
    DeleteAccountModalComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AppBarModule,
    ButtonModule
  ],
})
export class DeleteAccountModule { }
